// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getEquipmentItem, addSegmentToEquipment, removeSegmentFromEquipment, addProductTypeToEquipment, removeProductTypeFromEquipment, updateEquipmentItem } from '../../../state/actions/EquipmentActions';
import { getSegments, removeEquipmentFromSegment, addEquipmentToSegment } from '../../../state/actions/SegmentActions';
import { getPlanograms, deletePlanogram } from '../../../state/actions/PlanogramActions';
import { SegmentSection } from './SegmentSection.js';
import { PlanogramSection } from './PlanogramSection';
import { EquipmentSpecsSection } from './EquipmentSpecsSection';
import { ProductTypesSection } from './ProductTypesSection';
import { Loading} from '../../../containers/Loading';
import { AddSegmentToItemModal } from '../../../modals/AddSegmentToItemModal';
import { ProductTypeSelectionModal } from '../../../modals/ProductTypeSelectionModal';
import { EquipmentSpecsModal } from '../../../modals/EquipmentSpecsModal';
import { getProductTypes } from '../../../state/actions/CategoryActions';
import { ImageSection } from '../../../containers/ImageSection';

// COMPONENT
class EquipmentDetailsPage extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            equipmentItem: {},
            equipmentName: '',
            segments: [],
            planograms: [],
            productTypes: [],
            segmentModal: false,
            specsModal: false,
            typeModal: false,
            imageName: ''
        };

        this.updateSegments = this.updateSegments.bind(this);
        this.removeSegment = this.removeSegment.bind(this);
        this.removePlanogram = this.removePlanogram.bind(this);
        this.updateDependancies = this.updateDependancies.bind(this);
        this.updatePlanograms = this.updatePlanograms.bind(this);
        this.toggleSegmentModal = this.toggleSegmentModal.bind(this);
        this.addSegment = this.addSegment.bind(this);
        this.addType = this.addType.bind(this);
        this.removeType = this.removeType.bind(this);
        this.toggleTypeModal = this.toggleTypeModal.bind(this);
        this.toggleSpecsModal = this.toggleSpecsModal.bind(this);
        this.updateEquipment = this.updateEquipment.bind(this);  
    }

    componentDidMount(){
        this.props.getEquipmentItem(this.props.match.params.equipmentId);
    }

    updateDependancies(){
        if(this.props.equipmentItem != {} && this.props.equipmentItem.segments != null) {
            this.updateSegments();
            this.updatePlanograms();
        }
    }

    updatePlanograms(){
        this.props.getPlanograms(this.props.equipmentItem.id);
    }

    updateSegments(){
        if(this.props.equipmentItem.segments != undefined && this.props.equipmentItem.segments != null){
            this.props.getSegments(Object.keys(this.props.equipmentItem.segments));
        }
    }

    componentDidUpdate(prevProps) {
       
        if(JSON.stringify(this.props.equipmentItem) != JSON.stringify(prevProps.equipmentItem)) {
            this.setState({equipmentItem: this.props.equipmentItem});
            this.setState({equipmentName: this.props.equipmentItem.name});
            console.log(this.props.equipmentItem['preview-image']);
            this.setState({imageName: this.props.equipmentItem['preview-image']});

            this.updateDependancies();

            if(this.props.equipmentItem.productTypes != undefined){
                let typesIds = Object.keys(this.props.equipmentItem.productTypes);
                this.props.getProductTypes(typesIds);
            } else {
                this.setState({productTypes: []});
            }
        }

        if(this.props.segments != prevProps.segments){
            this.setState({segments: this.props.segments});
        }

        if(this.props.planograms != prevProps.planograms){
            this.setState({planograms: this.props.planograms});
        }

        if(this.props.addedEquipmentToSegment == true && prevProps.addedEquipmentToSegment == false){
            this.props.getEquipmentItem(this.props.match.params.equipmentId);
        }

        if(this.props.productTypes != prevProps.productTypes){
            this.setState({productTypes: this.props.productTypes});
        }

        if(this.props.removedTypeFromEquipment && !prevProps.removedTypeFromEquipment){
            if(this.props.equipmentItem.productTypes != undefined){
                let typesIds = Object.keys(this.props.equipmentItem.productTypes);
                this.props.getProductTypes(typesIds);
            } else {
                this.setState({productTypes: []});
            }
        }
    }

    toggleSegmentModal() {
        this.setState({
            segmentModal: !this.state.segmentModal
        });
    }

    toggleTypeModal() {
        this.setState({
            typeModal: !this.state.typeModal
        });
    }

    toggleSpecsModal() {
        this.setState({
            specsModal: !this.state.specsModal
        });
    }

    addType(typeID){
        this.props.addProductTypeToEquipment([typeID], this.state.equipmentItem.id);
    }

    removeType(typeID){
        this.props.removeProductTypeFromEquipment(typeID, this.state.equipmentItem.id);
    }

    addSegment(segmentIDs){
        this.props.addSegmentToEquipment(segmentIDs, [this.props.match.params.equipmentId]);
        this.props.addEquipmentToSegment(segmentIDs, [this.props.match.params.equipmentId]);

        this.updateSegments();
    }

    removeSegment(segmentId){
        this.props.removeEquipmentFromSegment(segmentId, this.props.equipmentItem.id);
        this.props.removeSegmentFromEquipment(segmentId, this.props.equipmentItem.id);
    }

    removePlanogram(planogramId) {
        this.props.deletePlanogram(planogramId);
    }

    updateEquipment(equipmentItem) {
        this.props.updateEquipmentItem(equipmentItem);
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Equipment: {this.state.equipmentName}</div>

                {(this.props.fetchingEquipmentItem || this.props.fetchingSegments || this.props.fetchingPlanograms) &&
                    <Loading/>
                }

                {!this.props.fetchingSegments && !this.props.fetchingPlanograms && !this.props.fetchingEquipmentItem && this.state.equipmentItem != {} && 
                    <div>
                        <ImageSection imageName={this.state.imageName} storageLocation={'preview-images'} width={300} height={150}/>
                        <EquipmentSpecsSection volume={this.state.equipmentItem.volume} dimensions={this.state.equipmentItem.dimensions} weight={this.state.equipmentItem.weight} toggleModal={this.toggleSpecsModal}/>
                        <PlanogramSection equipmentItem={this.props.equipmentItem} equipmentid={this.props.match.params.equipmentId} planograms={this.state.planograms} deletePlanogram={this.removePlanogram}/>
                        <ProductTypesSection types={this.state.productTypes} toggleModal={this.toggleTypeModal} removeType={this.removeType}/>
                        <SegmentSection emptyText={'There are no segments associated with this equipment'} subtitle={'These segments can access this equipment and any related planograms'} deleteItem={this.removeSegment} segments={this.state.segments} toggleModal={this.toggleSegmentModal}/>
                    </div>
                }

                {true && <AddSegmentToItemModal isOpen={this.state.segmentModal} toggleModal={this.toggleSegmentModal} addSegment={this.addSegment} assignedSegments={this.state.segments}/>}
                {true && <ProductTypeSelectionModal isOpen={this.state.typeModal} toggleModal={this.toggleTypeModal} addType={this.addType} assignedTypes={this.state.types}/>}
                {true && <EquipmentSpecsModal isOpen={this.state.specsModal} toggleModal={this.toggleSpecsModal} equipmentItem={this.state.equipmentItem} updateEquipment={this.updateEquipment}/>}
            </Fragment>
        );
    }
}

EquipmentDetailsPage.propTypes = {
    getEquipmentItem: PropTypes.func.isRequired,
    getSegments: PropTypes.func.isRequired,
    getPlanograms: PropTypes.func.isRequired,
    removeSegmentFromEquipment: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    equipmentItem: PropTypes.object.isRequired,
    segments: PropTypes.array.isRequired,
    planograms: PropTypes.array.isRequired,
    fetchingEquipmentItem: PropTypes.bool.isRequired,
    fetchedEquipmentItem: PropTypes.bool.isRequired,
    failedEquipmentItem: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    fetchingSegments: PropTypes.bool.isRequired,
    fetchedSegments: PropTypes.bool.isRequired,
    failedSegments: PropTypes.bool.isRequired,
    fetchingPlanograms: PropTypes.bool.isRequired,
    fetchedPlanograms: PropTypes.bool.isRequired,
    failedPlanograms: PropTypes.bool.isRequired,
    deletePlanogram: PropTypes.func.isRequired,
    addSegmentToEquipment: PropTypes.func.isRequired,
    addedEquipmentToSegment: PropTypes.bool.isRequired,
    addingEquipmentToSegment: PropTypes.bool.isRequired,
    addedSegmentToEquipment: PropTypes.bool.isRequired,
    addingSegmentToEquipment: PropTypes.bool.isRequired,
    removeEquipmentFromSegment: PropTypes.func.isRequired,
    addEquipmentToSegment: PropTypes.func.isRequired,
    addProductTypeToEquipment: PropTypes.func.isRequired,
    removeProductTypeFromEquipment: PropTypes.func.isRequired,
    getProductTypes: PropTypes.func.isRequired,
    productTypes: PropTypes.array.isRequired,
    fetchingProductTypes: PropTypes.bool.isRequired,
    fetchedProductTypes: PropTypes.bool.isRequired,
    failedProductTypes: PropTypes.bool.isRequired,
    addingTypeToEquipment: PropTypes.bool.isRequired,
    addedTypeToEquipment: PropTypes.bool.isRequired,
    addTypeToEquipmentFailed: PropTypes.bool.isRequired,
    removingTypeFromEquipment: PropTypes.bool.isRequired,
    removedTypeFromEquipment: PropTypes.bool.isRequired,
    removeTypeFromEquipmentFailed: PropTypes.bool.isRequired,
    updateEquipmentItem: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { equipmentItem, fetchingEquipmentItem, fetchedEquipmentItem, failedEquipmentItem, addingSegmentToEquipment, addedSegmentToEquipment, addingTypeToEquipment, addedTypeToEquipment, addTypeToEquipmentFailed, removingTypeFromEquipment,
        removedTypeFromEquipment, removeTypeFromEquipmentFailed } = state.equipmentReducer;
    const { segments, fetchingSegments, fetchedSegments, failedSegments, addingEquipmentToSegment, addedEquipmentToSegment } = state.segmentReducer;
    const { planograms, fetchingPlanograms, fetchedPlanograms, failedPlanograms } = state.planogramReducer;
    const { productTypes, fetchingProductTypes, fetchedProductTypes, failedProductTypes } = state.categoryReducer;
    return { equipmentItem, segments, fetchingEquipmentItem, fetchedEquipmentItem, failedEquipmentItem, fetchingSegments, fetchedSegments, failedSegments, planograms, fetchingPlanograms, fetchedPlanograms, 
        failedPlanograms, addingEquipmentToSegment, addedEquipmentToSegment, addingSegmentToEquipment, addedSegmentToEquipment, productTypes, fetchingProductTypes, fetchedProductTypes, failedProductTypes,
        addingTypeToEquipment, addedTypeToEquipment, addTypeToEquipmentFailed, removingTypeFromEquipment, removedTypeFromEquipment, removeTypeFromEquipmentFailed };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getEquipmentItem, getSegments, removeSegmentFromEquipment, addSegmentToEquipment, getPlanograms, deletePlanogram, removeEquipmentFromSegment, addEquipmentToSegment,
        addProductTypeToEquipment, removeProductTypeFromEquipment, getProductTypes, updateEquipmentItem }, dispatch)
);

// CONFIGURE REACT REDUX

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentDetailsPage));

// EXPORT COMPONENT

export { hoc as EquipmentDetailsPage };


// WEBPACK FOOTER //
// ./src/components/pages/Equipment/Details/EquipmentDetailsPage.js